(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profile-criterion-item', {
            parent: 'entity',
            url: '/profile-criterion-item',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.profileCriterionItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-items.html',
                    controller: 'ProfileCriterionItemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profileCriterionItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('profile-criterion-item-detail', {
            parent: 'entity',
            url: '/profile-criterion-item/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.profileCriterionItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-item-detail.html',
                    controller: 'ProfileCriterionItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profileCriterionItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProfileCriterionItem', function($stateParams, ProfileCriterionItem) {
                    return ProfileCriterionItem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile-criterion-item',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('profile-criterion-item-detail.edit', {
            parent: 'profile-criterion-item-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-item-dialog.html',
                    controller: 'ProfileCriterionItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfileCriterionItem', function(ProfileCriterionItem) {
                            return ProfileCriterionItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile-criterion-item.new', {
            parent: 'profile-criterion-item',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-item-dialog.html',
                    controller: 'ProfileCriterionItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                shortName: null,
                                sortOrder: null,
                                enable: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('profile-criterion-item', null, { reload: 'profile-criterion-item' });
                }, function() {
                    $state.go('profile-criterion-item');
                });
            }]
        })
        .state('profile-criterion-item.edit', {
            parent: 'profile-criterion-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-item-dialog.html',
                    controller: 'ProfileCriterionItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfileCriterionItem', function(ProfileCriterionItem) {
                            return ProfileCriterionItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile-criterion-item', null, { reload: 'profile-criterion-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile-criterion-item.delete', {
            parent: 'profile-criterion-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion-item/profile-criterion-item-delete-dialog.html',
                    controller: 'ProfileCriterionItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProfileCriterionItem', function(ProfileCriterionItem) {
                            return ProfileCriterionItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile-criterion-item', null, { reload: 'profile-criterion-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
